import { array, mixed, object, ObjectSchema, string } from "yup";
import {
	CharacterLimitExceeded,
	EnterTruckNameText,
	InvalidTruckNameText,
	RequestTruckDateFormError,
	SelectAccountNumberText,
	SelectProductLineText,
	SelectRequestDateText,
	SelectShippingAddressErrorText
} from "constants/text";
import { models } from "types/api/viewModels";
import { isDateWithinBusinessDayRange } from "utils/date";
import { truckStopSchema } from "./truckStopSchema";

export const START_BUSINESS_DAY_RANGE = 10;
export const END_BUSINESS_DAY_RANGE = 90;

export interface TruckStepOneSchema {
	accountNumber?: models["CustomerAccountViewModel"] | null;
	productLine?: models["ProductLineViewModel"] | null;
	truckName?: string | null;
	requestDate?: string;
	stops?: models["TruckStopViewModel"][] | null;
}

export const truckNameValidator = string()
	.required(EnterTruckNameText)
	.max(15, CharacterLimitExceeded)
	.test("valid characters", InvalidTruckNameText, (value) => {
		if (typeof value !== "string") return true;
		return !value.startsWith(" ");
	});

export const requestDateValidator = string()
	.required(SelectRequestDateText)
	.test("isDateWithinBusinessDayRange", RequestTruckDateFormError, (value) => {
		if (!value) return true;
		return isDateWithinBusinessDayRange(new Date(value), START_BUSINESS_DAY_RANGE, END_BUSINESS_DAY_RANGE);
	});

export const truckStepOneSchemaObject = {
	accountNumber: mixed<models["CustomerAccountViewModel"]>().required(SelectAccountNumberText),
	productLine: mixed<models["ProductLineViewModel"]>().when("accountNumber", {
		is: (val: models["CustomerAccountViewModel"] | null) => val !== null && val !== undefined,
		then: (schema) => schema.required(SelectProductLineText),
		otherwise: (schema) => schema.notRequired()
	}),
	truckName: truckNameValidator,
	requestDate: requestDateValidator,
	stops: array().of(truckStopSchema).required(SelectShippingAddressErrorText)
} as const;

export const schema: ObjectSchema<TruckStepOneSchema> = object(truckStepOneSchemaObject);
